import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import BankTransactionFileUpdateWillMount from "../../../Middleware/Middlewares/BankTransactionFileUpdateWillMount";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PaymentCounterpartyDescriptionInfoForList from "../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList";

class BankTransactionFileUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_PAYMENT_UPDATE_CLEAR;
  protected fileId: number;

  protected middlewares: MiddlewareInterface[] = [
    BankTransactionFileUpdateWillMount
  ];

	public state = {
    showList: true,

    transactionFile: null,
    payments: [],
    paymentsToVerify: [],
    currentPayment: null,
    chargesForCurrentPayment: [],
    isSaving: false,
    isFinalPopupOpen: false,

    chargeChoice: "existing",
    directIndirectCharges: [],
		selectedDirectIndirectChargesRows: [],
		objectCharges: [],
		selectedObjectChargesRows: [],
    selectedEntityForExistingCharge: null,
    amountForCharge: "",
    currencyIdForCharge: "",
    showChargeOwnerChoice: true,
    paymentClassId: "",
    chargeOwnerChoice: "person",
    selectedPersonForCharge: null,
    selectedCompanyForCharge: null,
    selectedPayment: null,
    typeIdForCharge: "",
    typeIdForChargeManuallyChanged: false,
    selectedEntityForCharge: null,
    selectedEntityForChargeManuallyChanged: false,
    periodForCharge: 3,
    firstDateForCharge: null,
    descriptionForCharge: "",
    descriptionForChargeIsManuallyChanged: false,
    renderChargeType: true,
    isCreateChargeTypePopupOpen: false,
    isDifferentClassesPopupOpen: false,
    isChooseExistingChargePopupOpen: false,
    chargeIds: [],

    isWrongChargePopupOpen: false,
    payerChoice: "person",
    selectedPersonForPayment: null,
    selectedCompanyForPayment: null,
    filter: "unverified"
  };

  constructor(public props) {
    super(props);
  }

  public getFilteredPayments = (payments) => {
    switch(this.state.filter) {
      case "unverified": 
        return payments.filter(payment => !payment?.isProcessed);

      case "all": 
        return payments;

      default:
        break; 
    }
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  }

  public getPaymentsForList = (payments: PaymentInterface[]) => {
    return this.getFilteredPayments(payments)
      .map((payment: PaymentInterface, index: number) => {
        if (!payment) {
          return;
        }

        let color = "#43A047";

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = "#F44336";
          } else {
            color = "#F5A623";
          }
        }

        return (
          <TableRow
            hover
            key={`payment-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              const paymentsToVerify = [...new Set([payment, ...this.state.paymentsToVerify])];
              const currentPayment = paymentsToVerify[0]

              this.setState({
                paymentsToVerify: paymentsToVerify,
                currentPayment: currentPayment,
                showList: false,
                hasModifiedData: false
              }, () => {
                this.updateFilterState();

                return this.redirect(`/app/transaction-file/${this.fileId}/bank-transaction/${currentPayment.id}`)
              })
            }}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  style={{color: color}}
                  className="icon icon-ic-payment"
                ></div>
              </div>
            </TableCell>
            <TableCell style={{width: "10%"}}>{this.formatter.formatDate(payment.dateOfThePayment)}</TableCell>
            <TableCell style={{width: "50%"}}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell style={{width: "15"}}>
              <div style={{display: "flex", justifyContent: "center"}}>
                {
                  payment.removed && <div>{this.trans("removed")}</div>
                }
                {
                  !payment?.removed && !payment?.isProcessed && <div>{this.trans("to-verify")}</div>
                }
              </div>
            </TableCell>
            <TableCell>
              {payment.creationTypeDisplayName && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div className="list-label creation-type-label">
                    {payment.creationTypeDisplayName}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell style={{textAlign: "right", width: "25%", paddingRight: "20px" }}>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <span>{payment.paymentClass.id == PaymentClassContainer.pickIdFromLabel("Payable")  && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(payment.amount, payment.currency)}</span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderPaymentList = (payments: PaymentInterface[]) => {
    return (
      <div className="component-wrapper no-margin-top" style={{position: "relative" as "relative"}}>
        <Card className="card">
          <div className="list-filters-wrapper">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingTop: "3px"
              }}
            >
              <RadioGroup
                name="paymentsFilters"
                value={this.state.filter}
                onChange={this.changeFilter}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginRight: "15px"
                }}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio color="primary" />}
                  label={
                    (<span>{this.trans("all")}</span>)}
                />
                <FormControlLabel
                  value="unverified"
                  control={<Radio color="primary" />}
                  label={
                    (<span>{this.trans("to-verify")}</span>)}
                />
              </RadioGroup>
            </div>
          </div>
          <TableComponent
            {...this.props}
            className="listing-table padding-last-item"
            subtitle={this.trans("page/banktransactionfile-section/listoftransaction-info/transactionnotfound")}
            rows={this.getPaymentsForList(payments)}
            noPagination={true}
          />
        </Card>
      </div>
    );
  }
  
  public updateFilterState = () => {
    this.props.dispatch({
      type: Constants.TRANSACTION_FILTER_UPDATE_STATE,
      payload: {
        fileId: this.state.transactionFile?.id,
        filter: this.state.filter,
        transactionIds: this.getFilteredPayments(this.state.payments).map(payment => payment.id)
      }
    });
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, this.updateFilterState);
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button" style={{justifyContent: "flex-end", alignItems: "center"}}>
            <div className="back-arrow-wrapper" onClick={this.redirectBack}>
              <div className="icon icon-ic-arrow-back icon-color"></div>
            </div>
            <div className="title-wrapper">
              <h1>{this.state.transactionFile?.description}</h1>
            </div>
            <div className="button-container">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({
                    hasModifiedData: false
                  }, () => {
                    if (this.state.paymentsToVerify.length > 0) {
                      this.updateFilterState();
                      
                      return this.redirect(`/app/transaction-file/${this.fileId}/bank-transaction/${this.state.currentPayment && this.state.currentPayment.id}`);
                    } else {
                      return this.redirectBack();
                    }
                  })
                }}
              >
                {
                  this.state.paymentsToVerify.length > 0 ? this.trans("button-continue") : this.trans("button-done")
                }
              </Button>
            </div>
          </div>

          <div className="component-bank-transactions">
            {this.renderPaymentList(this.state.payments)}
          </div>
        </div>

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.bankTransactionFileUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  BankTransactionFileUpdate
);
